module.exports = __webpack_public_path__ + "img/map4.d477e653.jpg";